export enum ID_SURNAME_TYPE {
  PadreMadre = '1',
  Padre = '3',
  MadrePadre = '2',
  Madre = '4',
  Altro = '5',
}
